import { useWaypointReference } from "@/components/r3f/utils/placeholder-preview";
import {
  ElementIconType,
  selectLocationType,
  useElementIcon,
} from "@/components/ui/icons";
import { IElementWaypoint } from "@/hooks/use-placeholders";
import { useAppSelector } from "@/store/store-hooks";
import {
  selectAncestor,
  selectIElement,
} from "@faro-lotv/app-component-toolbox";
import {
  IElementTypeHint,
  isIElementGenericDataset,
} from "@faro-lotv/ielement-types";

/**
 * @param waypoint The capture waypoint
 * @returns the icon of the capture in the project tree. Video mode frames are shown as time points
 * in the tree, so they use the icon of their video recording instead
 */
export function useCaptureTreeIcon(
  waypoint: IElementWaypoint | undefined,
): ElementIconType | undefined {
  const reference = useWaypointReference(waypoint);
  const dataset = useAppSelector(
    selectAncestor(waypoint, isIElementGenericDataset),
  );
  const parent = useAppSelector(selectIElement(reference?.parentId));
  const locationType = useAppSelector(selectLocationType(reference?.id ?? ""));
  const referenceIcon = useElementIcon(reference, parent, locationType);

  if (!reference) return;
  return dataset?.typeHint === IElementTypeHint.dataSetVideoWalk
    ? ElementIconType.DataSessionVideoRecording
    : referenceIcon;
}
